import QuizFooterWrapper from './QuizFooterWrapper';

export default QuizFooterWrapper;
